var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46161 4C3.43873 4 4.23084 3.10457 4.23084 2C4.23084 0.89543 3.43873 0 2.46161 0C1.48449 0 0.692383 0.89543 0.692383 2C0.692383 3.10457 1.48449 4 2.46161 4Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46161 12C3.43873 12 4.23084 11.1046 4.23084 10C4.23084 8.89543 3.43873 8 2.46161 8C1.48449 8 0.692383 8.89543 0.692383 10C0.692383 11.1046 1.48449 12 2.46161 12Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46161 20C3.43873 20 4.23084 19.1046 4.23084 18C4.23084 16.8954 3.43873 16 2.46161 16C1.48449 16 0.692383 16.8954 0.692383 18C0.692383 19.1046 1.48449 20 2.46161 20Z",
    fill: "#D8D8D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.7d5ca7a76faa9cb73d03182abcecb534.svg";
export { ForwardRef as ReactComponent };